import { Container, Grid, Stack, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useRequest } from '../api/Request';
import { AuthStatus, useAuth } from '../auth/Auth';
import { Track } from '../database/music';
import { SingleYouTubeVideoList } from '../database/videos';
import SocialBar from '../socials/SocialBar';
import LoadingPage from '../loading/LoadingPage';
import { useNavigate } from 'react-router';
import VerificationCodeInput from '../components/VerificationCodeInput';
import LegalBar from '../components/LegalBar';
import { useLocalStorage } from 'usehooks-ts';

const HomePage = () => {
    const auth = useAuth();
    const trackRequest = useRequest<Track>();
    const videoRequest = useRequest<SingleYouTubeVideoList>();
    const [showStellarTextField, setShowStellarTextField] = useState(false);
    const [stellarInput, setStellarInput] = useState('');
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:800px)');
    const [, setHasAccess] = useLocalStorage('enterStellarSpacebarAccess', false);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === ' ' && stellarInput === 'stellar') {
                setHasAccess(true);
                navigate('/ess');
            }
            if (event.key === 'Enter') {
                setShowStellarTextField((prev) => !prev);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [navigate, stellarInput, setHasAccess]);

    const handleCodeChange = (value: string) => {
        setStellarInput(value);
    };

    if (auth.status === AuthStatus.Loading && !trackRequest.data && !videoRequest.data) {
        return <LoadingPage />;
    }

    return (
        <Container
            maxWidth={false}
            sx={{
                pt: 6,
                pb: 4,
                margin: 0,
                padding: 0,
                marginBottom: isMobile ? '100px' : 0,
            }}
        >
            <div
                className='video-container'
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: -10,
                }}
            >
                <video
                    autoPlay
                    playsInline
                    loop
                    muted
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        filter: 'brightness(50%)',
                    }}
                >
                    <source src='HomeVideo.mp4' type='video/mp4' />
                    Your browser does not support the video tag.
                </video>
            </div>
            <Grid container sx={{ maxWidth: '100%', margin: 0 }}>
                <Grid
                    item
                    md={3.3}
                    sm={12}
                    xs={12}
                    padding='30px'
                    sx={{ display: 'flex', justifyContent: 'center' }}
                >
                    {/* <Stack maxWidth='400px'>
                        {trackRequest.data && (
                            <MusicChoice trackId={trackRequest.data?.id} />
                        )}
                        {videoRequest.data && (
                            <VideoChoice video={videoRequest.data?.items[0]} />
                        )}
                    </Stack> */}
                </Grid>
                <Grid item md={5.1} sm={0} xs={0}></Grid>
                <Grid
                    item
                    md={3.6}
                    sm={12}
                    xs={12}
                    marginTop='30px'
                    padding='30px'
                    sx={{ display: 'flex', justifyContent: 'center' }}
                >
                    <Stack spacing={2} maxWidth='400px'>
                        {/* {artistUser?.bio && (
                            <AboutMe aboutMe={artistUser?.bio} />
                        )} */}
                        {showStellarTextField && (
                            <VerificationCodeInput
                                length={7}
                                onChange={handleCodeChange}
                                autoFocus
                            />
                        )}
                        {/* {artistUser?.artistInfo?.funFact && (
                            <FunFact funFact={artistUser?.artistInfo.funFact} />
                        )} */}
                    </Stack>
                </Grid>
            </Grid>
            <SocialBar />
            <LegalBar />
        </Container>
    );
};

export default HomePage;
